var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "Else Aksiyonları Düzenle",
        width: "800px",
        okText: "Kaydet",
        cancelText: "İptal",
        bodyStyle: { padding: "24px" },
      },
      on: { cancel: _vm.onCancel, ok: _vm.onSave },
    },
    [
      _c(
        "div",
        { staticClass: "else-actions-editor" },
        [
          _c("p", { staticClass: "description" }, [
            _vm._v(
              "\n            Hiçbir kural eşleşmediğinde çalışacak varsayılan aksiyonları tanımlayın\n        "
            ),
          ]),
          _vm._v(" "),
          _c("ActionsEditor", {
            attrs: { "when-type": "contact_created" },
            model: {
              value: _vm.localActions,
              callback: function ($$v) {
                _vm.localActions = $$v
              },
              expression: "localActions",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }